<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Address"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="address"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetAddress
        :address="editor"
      >
      </FieldsetAddress>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded && forms.address"
  >
    <ItpButton
      type="submit"
      :text="'Save'|gettext"
      :form="forms.address"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class Address extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  parent!: object;

  @Watch('parent')
  onParent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent")
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.item || this.$fn.schemaDefaults('CreateCompanyAddress')
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  createTitle!: any;
  editTitle!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        editor: null,
        createTitle: this.$fn.pgettext("Addresses", "Add address"),
        editTitle: this.$fn.pgettext("Addresses", "Edit address"),
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.resource.id == null ? this.createTitle : this.editTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8242_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8242, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_8248_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_8248, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_closeComponent_8250_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_8250, alias=undefined
    return {
      result: {
        ok: true,
        value: "deleted",
      }
      ,
    }
  }

  async act_1040167445267876_rest_8246_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_8246, alias=submit
    return {
      method: "save",
      container: this.parent.addresses,
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8242: actions.CloseModalAction;
    evh_7315092382398562_close_8241: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8244: actions.CloseComponentAction;
    evh_2248226175642056_close_8243: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_8248: actions.CloseComponentAction;
    evh_1040167445267876_saved_8247: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_8250: actions.CloseComponentAction;
    evh_1040167445267876_deleted_8249: actions.EventHandlerImpl;
    act_1040167445267876_rest_8246: actions.RestAction;
    evh_1040167445267876_submit_8245: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8252: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8251: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8242 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8242_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8241 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8242,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8241],
      }
    );
    const act_2248226175642056_closeComponent_8244 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8243 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8244,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8243],
      }
    );
    const act_1040167445267876_closeComponent_8248 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_8248_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_8247 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_8248,
        event: "saved",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_closeComponent_8250 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_8250_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_deleted_8249 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_8250,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_rest_8246 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_8246_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_saved_8247, evh_1040167445267876_deleted_8249],
      }
    );
    const evh_1040167445267876_submit_8245 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_8246,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8245],
      }
    );
    const act_1419464017721962_closeComponent_8252 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8251 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8252,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8251],
      }
    );
    return {
      act_7315092382398562_closeModal_8242,
      evh_7315092382398562_close_8241,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8244,
      evh_2248226175642056_close_8243,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_8248,
      evh_1040167445267876_saved_8247,
      act_1040167445267876_closeComponent_8250,
      evh_1040167445267876_deleted_8249,
      act_1040167445267876_rest_8246,
      evh_1040167445267876_submit_8245,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_8252,
      evh_1419464017721962_clickPreventStop_8251,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_rest_8246,
    }
  }
}

Vue.component("Address", Address);

</script>